__turbopack_context__.v({
  "bingoPlaceholder": "styles-module-scss-module__eGRE1a__bingoPlaceholder",
  "bingoRoomsContainerRoot": "styles-module-scss-module__eGRE1a__bingoRoomsContainerRoot",
  "bingoRoomsContainerRoot3D": "styles-module-scss-module__eGRE1a__bingoRoomsContainerRoot3D",
});
